import { Carousel as MantineCarousel } from '@mantine/carousel';

export const Carousel = MantineCarousel.extend({
	defaultProps: {
		withControls: false,
		emblaOptions: {
			dragFree: true,
		},
	},
});
